/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
*/

/**
* Directive that handles audio blocks
*/
angular.module('bulbApp.contentEditorModule')

  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  .directive('audioBlock', ['$timeout', 'CONFIG', 'JWPLAYER', audioBlock]);

function audioBlock($timeout, CONFIG, JWPLAYER) {
  return {
    restrict: 'E',
    require: '?^contentBlock',
    controller: 'AudioBlockController as audioBlockCtrl',
    templateUrl: 'ajs/components/contenteditor/audioblock.html',
    link(scope, element, attrs, contentBlockCtrl) {
      // Used to determine how to render the audio block
      const { mode } = scope.pageViewCtrl.page;

      $timeout(() => {
        const bulbAudioContainer = element.find('.bulb-audio');
        if (mode === 'default') {
          bulbAudioContainer.addClass('bulb-audio-initial-width');
          scope.$watch(() => contentBlockCtrl.alignment, (alignment) => {
            bulbAudioContainer.css('width', '100%');

            if (alignment === 'right') {
              bulbAudioContainer.css('padding-left', '44px');
            } else {
              bulbAudioContainer.css('padding-left', '');
            }
          });
        }
      }, JWPLAYER.defaultOptions.timeout);
    },
  };
}
